var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 0.433472C16.8876 0.433472 18.4995 2.0466 18.4995 4.03621V14.8444C18.4995 15.5866 17.6589 15.9937 17.0649 15.5479L13.7188 13.043H4.09977C2.11171 13.043 0.499838 11.4299 0.499838 9.44031V4.03621C0.499838 2.0466 2.11171 0.433472 4.09977 0.433472H14.8996ZM14.8996 2.23484H4.09977C3.10529 2.23484 2.29981 3.04095 2.29981 4.03621V9.44031C2.29981 10.4356 3.10529 11.2417 4.09977 11.2417H13.9996C14.194 11.2417 14.3785 11.2939 14.5342 11.411L16.6995 13.043V4.03621C16.6995 3.04095 15.8941 2.23484 14.8996 2.23484Z",
    fill: "#00A4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 2H3.125C1.95094 2 1 2.895 1 4V10C1 11.105 1.95094 12 3.125 12H14.8125C15.042 12 15.2598 12.058 15.4436 12.188L18 14V4C18 2.895 17.0491 2 15.875 2Z",
    fill: "#00A4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.df90bdceb9885a6a14af5a67b4798819.svg";
export { ForwardRef as ReactComponent };